export default class Gate{
  constructor(user){
    this.user = user;
  }

  isAdmin(){
    return this.user.role_names.includes('admin');
  }

  isSuperAdmin(){
    return this.user.role_names.includes('sa');
  }

  isModerator(){
    return this.user.role_names.includes('moderator');
  }

  isJuror(){
    return this.user.role_names.includes('juror');
  }
}
